<template>
  <div>
    <el-page-header @back="close" :content="form.id > 0 ? '编辑视频短信模板' : '新增视频短信模板'"></el-page-header>
    <el-row>
      <el-col :span="12" :offset="3">
        <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
          <el-form-item label="业务" prop="code" :error="errors.code">
            <Cascade ref="cascade" v-model="form.code" @change="loadGroup"></Cascade>
          </el-form-item>
          <el-form-item label="名称" prop="name" :error="errors.name">
            <el-input v-model="form.name" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="分組" prop="groupId">
            <RemoteSelect v-model="form.groupId" :options="groups" value-name="id" label-name="name"></RemoteSelect>
          </el-form-item>
          <el-form-item label="标题" prop="title" :error="errors.title">
            <el-input v-model="form.title" maxlength="15" show-word-limit></el-input>
          </el-form-item>
<!--          <el-form-item label="模板类型" prop="type" :error="errors.type">-->
<!--            <el-select v-model="form.type" placeholder="请选择">-->
<!--              <el-option label="静态模板" value="1"></el-option>-->
<!--              <el-option label="动态模板" value="2"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item :label="getItemLabel(item)" v-for="(item, i) in items" :key="i" :name="i">
            <el-row>
              <el-col :span="20">
                <template v-if="item['type'] === 'text'">
                  <el-input type="textarea" v-model="item.content" :rows="5" maxlength="500"
                            show-word-limit></el-input>
                  <el-checkbox v-model="unsubscribe" @change="changeUnsubscribe(i)">退订</el-checkbox>
                  <div style="color: red;">
                    <b>根据工信部要求：短信内容中，回复退订“T”或“TD”等退订格式，统一改为使用“拒收请回复R”</b><br>
                    <b>示例：短信息正文内容，拒收请回复R</b><br>
                  </div>

<!--                  <div class="help-text" v-if="form.type === '2'">-->
                  <div class="help-text">
                    变量占位符格式为：[[name]]<br>
                    举例说明：尊敬的<strong>[[姓名]]</strong>，您的会员将于<strong>[[日期]]</strong>到期。<br>
                    <p>注意：变量个数不要超过10个，变量名称不能重复。</p>
                  </div>
                </template>
                <template v-else-if="item['type'] === 'img'">
                  <el-upload :action="$utils.getApiPath('/mms/template/upload')"
                             list-type="picture" :headers="headers"
                             :file-list="getFileList(item.content)"
                             :limit="1" accept=".jpg,.gif"
                             :on-success="(res) => {uploadSuccess(res, i)}">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/gif文件</div>
                  </el-upload>
                </template>
                <template v-else-if="item['type'] === 'video'">
                  <el-upload :action="$utils.getApiPath('/mms/template/upload')"
                             :headers="headers"
                             :file-list="getFileList(item.content)"
                             :limit="1" accept=".mp4,.3gp"
                             :on-success="(res) => {uploadSuccess(res, i)}">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传mp4/3gp文件</div>
                  </el-upload>
                </template>
                <template v-else-if="item['type'] === 'mp3'">
                  <el-upload :action="$utils.getApiPath('/mms/template/upload')"
                             :headers="headers"
                             :file-list="getFileList(item.content)"
                             :limit="1" accept=".mp3"
                             :on-success="(res) => {uploadSuccess(res, i)}">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传mp3文件</div>
                  </el-upload>
                </template>
              </el-col>
              <el-col :span="4" style="text-align: right">
                <el-link icon="el-icon-delete" :underline="false" @click="removeItem(i)">删除
                </el-link>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="完整链接" prop="link" :error="errors.link">
            <el-input v-model="form.link"></el-input>
            <div class="help-text">
              <p>如文案中带有变量链接，请提供一个完整链接地址，用于运营商审核使用。</p>
            </div>
          </el-form-item>
          <div style="color: red;margin-top: 20px" v-if="form.used">
            <b>该模板已被使用，不可再次编辑！</b>
          </div>
          <template v-else>
            <div style="color: red;margin-top: 10px;padding-left: 100px">
              提示：<br>
              1、如文案中有链接，根据电信政策要求，必须在链接前加上http://或https://；否则会审核拒绝。<br>
              2、总内容大小不可超过 1.8M。<br>
              3、文案中不要使用井号，这个是电信运营商的变量标识符。
            </div>
            <el-form-item style="margin-top: 20px">
              <el-dropdown @command="add" style="margin-right: 50px">
                <el-button type="success">
                  添加<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="text">文本内容</el-dropdown-item>
                  <el-dropdown-item command="img">图片</el-dropdown-item>
                  <el-dropdown-item command="video">视频</el-dropdown-item>
                  <el-dropdown-item command="mp3">音频</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </template>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Cascade from '@/components/Cascade'
import RemoteSelect from '@/components/RemoteSelect'

export default {
  components: {
    Cascade,
    RemoteSelect
  },
  props: ["id", "groupId"],
  data() {
    return {
      headers: {
        Authorization: this.$utils.getAuthToken(),
      },
      form: {
        id: this.id,
        name: "",
        groupId: 0,
        title: "",
        type: "1",
        content: [],
        status: {value: "pass"},
        code: "",
        used: false,
        link: "",
      },
      rules: {
        name: [
          {required: true, message: "请填写模板名称"}
        ],
        title: [
          {required: true, message: "请填写标题"},
          {max: 15, message: "标题最大长度15个字符"},
        ],
        type: [
          {required: true, message: "请选择模板类型"}
        ],
        code: [
          {required: true, min: 6, message: "请选择业务"}
        ],
        groupId: [
          {required: true, message: "请选择分组"}
        ]
      },
      errors: {},
      unsubscribe: false,
      groups: [],
      items: [],
    }
  },
  beforeMount() {
    if (this.form.id > 0) {
      this.$axios.get("/video_template/get/" + this.form.id).then(result => {
        result['content'] = JSON.parse(result['content']);
        this.$utils.merge(this.form, result);
        this.items = this.form['content']['items'];
      })
    } else {
      this.add("text");
    }

    this.loadGroup(this.$root.code);
  },
  methods: {
    getFileList(url) {
      if (url) {
        return [{url: url, name: url.substring(url.lastIndexOf("/") + 1)}]
      } else {
        return [];
      }
    },
    loadGroup(code) {
      this.form.groupId = 0;
      if (code && code.length > 5) {
        this.$axios.post("/group/list", {
          rules: [
            {field: "type", value: "video"},
            {field: "code", value: code},
          ]
        }).then(data => {
          this.groups = [{id: 0, name: "默认"}].concat(data);
          this.form.groupId = this.groupId;
        });
      } else {
        this.groups = [{id: 0, name: "默认"}];
      }
    },
    add(command) {
      this.items.push({"type": command, content: ""});
    },
    getItemLabel(item) {
      let type = item['type'];
      if (type === "text") {
        return "文本内容";
      } else if (type === "img") {
        return "图片";
      } else if (type === "video") {
        return "视频";
      }  else if (type === "mp3") {
        return "音频";
      } else {
        return "";
      }
    },
    removeItem(index) {
      this.$delete(this.items, index);
    },
    uploadSuccess(response, activeItem) {
      if (response['success'] && response["data"]) {
        this.items[activeItem]['content'] = "/file/" + response['data'];
      } else {
        this.$message.error("上传素材失败，请重新上传！");
      }
    },
    submit() {
      let data = JSON.parse(JSON.stringify(this.form));
      let items = this.items.filter(item => {
        return !!item['content'];
      });

      data.content = JSON.stringify({title: this.form.title, items: items});

      data.type = data.content.indexOf("[[") >= 0 ? "2" : "1";

      // let hasText = false;
      // if (this.form.type === "2") {
      //   items.forEach(item => {
      //     if (item['type'] === 'text') {
      //       hasText = true;
      //     }
      //   })
      // }
      //
      // if (hasText && data.content.indexOf("[[") < 0) {
      //   this.$message.error("动态模板中的模板内容需包含占位符！");
      //   return;
      // }

      if (data.content.indexOf("#") >= 0) {
        this.$message.error("文案中不能使用井号！");
        return;
      }

      let url = this.form.id > 0 ? "/video_template/edit" : "/video_template/save";
      this.$utils.submit(this.$refs.form, url, data, () => {
        this.$emit("close", true);
      }, (data) => {
        this.errors = data;
      });
    },
    close() {
      this.$emit("close", false);
    },
    changeUnsubscribe(index) {
      let content = this.items[index]['content'];
      if (this.unsubscribe) {
        content += "拒收请回复R";
      } else {
        if (content && content.endsWith("拒收请回复R")) {
          content = content.substring(0, content.indexOf("拒收请回复R"));
        }
      }
      this.items[index]['content'] = content;
    }
  }
}
</script>
<style scoped>
>>>.el-upload-list__item {
  transition: none !important;
}
</style>